<template>
  <section class="s-search">
    <div class="s-breadcrumb-target"></div>

    <Loader v-if="isLoading" display="absolute"></Loader>

    <div class="s-search__form">
      <div class="s-search__search">
        <div class="s-search__search__cont">
          <label for="search-res-input" class="s-search__search__label"></label>
          <input
            id="search-res-input"
            type="text"
            placeholder="Αναζήτηση"
            v-model="term"
            @keypress="searchKeyPressed($event)" />
          <a
            href="javascript:void(0)"
            @click="clearSearchInput"
            class="s-search__search__clear"></a>
        </div>
      </div>
    </div>

    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

    <div class="s-search__main" v-if="!errorMsgs.length && results.length">
      <div class="s-search__head">
        <div class="s-search__titles">
          <h1 class="s-search__title">{{ resultsTitle }}</h1>
          <h2 class="s-search__countTitle">{{ countTitle }}</h2>
        </div>

      
      </div>

      <div class="s-search__cont">
        <ul v-if="resultsCount > 0" class="s-search__list">
          <li
            v-for="(item, index) in results"
            :key="'search-result-' + index"
            class="s-search__list__item">
            <a :href="item.url" class="b-career-card">
              <h3 class="b-career-card__title">{{ item.title }}</h3>
              <div class="b-career-card__date">{{ item.date }}</div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="s-search__noResults" v-if="resultsCount === 0">
      <div class="s-search__noResults__main">
        <NoResults
          :title="noResultsTitle"
          :desc="dictionary.noResultDesc"></NoResults>
      </div>
    </div>

    <div class="s-search__pagination">
      <Pagination
        :key="'search-pagination-' + paginationUpdateKey"
        :results-count="resultsCount"
        :page-size="pageSize"
        @page-changed="pageChanged"></Pagination>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Alert from '../components/common/Alert.vue'
import Loader from '../components/common/Loader.vue'
import Pagination from '../components/common/Pagination.vue'
import NoResults from '../components/common/NoResults.vue'

import * as lib from '../../lib/lib'

export default {
  components: {
    Alert,
    Loader,
    Pagination,
    NoResults,
  },

  data() {
    return {
      // default

      isLoading: false,
      errorMsgs: [],
      results: [],
      resultsCount: 0,
      term: '',
      submittedTerm: '',
      pageSize: 10,
      page: 1,
      dataRequestOnce: false,
      paginationUpdateKey: 0,
    }
  },
  computed: {
    resultsTitle() {
      return this.dictionary.resultsTitle.replace('{term}', this.submittedTerm)
    },
    countTitle() {
      return this.dictionary.countTitle
        .replace('{y}', this.resultsCount)
        .replace('{x}', this.page * this.pageSize)
    },
    noResultsTitle() {
      return this.dictionary.noResultsTitle.replace(
        '{term}',
        this.submittedTerm
      )
    },
  },
  mounted() {
    if (lib.getUrlParam('term')) {
        this.term = lib.getUrlParam('term')
    }
    
    this.fetchData(1)
    this.iniSearchTerm()
  },

  methods: {
    fetchData(page) {
      this.isLoading = true

      const payload = {
        page: page,
        pageSize: this.pageSize,
        term: this.term,
      }
      if (this.dataRequestOnce) {
        lib.scrollToElem(jQuery(this.$el))
      }

      axios
        .post(this.configuration.endpointSearchResults, payload)
        .then((response) => {
          const { hasError, errorMessages, data } = response.data

          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.isLoading = false

          this.resultsCount = data.resultsCount
          this.results = data.results
          this.submittedTerm = this.term

          lib.appendUrlParam('term', this.term)

          this.$nextTick(() => {
            this.handleSuccess()
          })

          console.log('records', this.records)
        })
        .catch((errors) => {
          console.error(errors)
        })

      this.dataRequestOnce = true
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    searchKeyPressed() {
      if (event.which == 13 && this.term.length >= 3) {
        this.paginationUpdateKey++
        this.fetchData(1)
      }
    },

    clearSearchInput() {
      this.term = ''
    },

    iniSearchTerm() {
      const urlTerm = lib.getUrlParam('term')

      if (urlTerm) {
        this.term = urlTerm
        this.submittedTerm = urlTerm
      }
      lib.appendUrlParam('page', this.page)
    },

    pageChanged(newPage) {
      this.page = newPage
      lib.appendUrlParam('page', this.page)

      this.fetchData(newPage)
    },
  },

}
</script>
